(function () {
  function initFooterAccordions() {
    var buttons = document.querySelectorAll('.footer-acc__button');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.footerAccInit === 'true') return;
      button.dataset.footerAccInit = 'true';

      button.addEventListener('click', function () {
        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        var panelId = button.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);

        // Close all other accordions
        buttons.forEach(function (otherButton) {
          if (otherButton !== button) {
            otherButton.setAttribute('aria-expanded', 'false');
            var otherPanelId = otherButton.getAttribute('aria-controls');
            var otherPanel = document.getElementById(otherPanelId);
            if (otherPanel) otherPanel.setAttribute('hidden', '');
          }
        });

        // Toggle current accordion
        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('hidden', '');
        } else {
          button.setAttribute('aria-expanded', 'true');
          if (panel) panel.removeAttribute('hidden');
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', initFooterAccordions);
  initFooterAccordions();
})();
